/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maroon_Equal_Mayfly_FeelInputs */

const fr_maroon_equal_mayfly_feel = /** @type {(inputs: Maroon_Equal_Mayfly_FeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requiert une capture`)
};

/**

* @param {Maroon_Equal_Mayfly_FeelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const maroon_equal_mayfly_feel = /** @type {((inputs?: Maroon_Equal_Mayfly_FeelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maroon_Equal_Mayfly_FeelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_maroon_equal_mayfly_feel(inputs)
});